import { cn } from "@moe/priv/utils";
import { Link } from "@tanstack/react-router";
interface Props {
  className?: string;
}

export function Rules({ className }: Props) {
  return (
    <div
      className={cn(
        "bg-float border-line mb-4 h-auto w-full rounded-xl border p-4 shadow-md md:mb-0 md:w-[232px]",
        className
      )}
    >
      <h3 className="text-tx-primary mb-3 font-semibold md:text-lg">Community Guidelines</h3>

      <ul className="text-tx-secondary mb-3 space-y-2 text-sm list-disc pl-5">
        <li>No underage characters or child-like depictions</li>
        <li>No incest/NSFW family content</li>
        <li>No bestiality or non-anthropomorphic animal content</li>
        <li>Non-con requires "Dead Dove" tag</li>
      </ul>

      <Link className="text-tx-secondary text-xs" to="/guidelines">
        Read full <span className="text-action-secondary hover:text-action-primary underline">guidelines</span> for more
        details.
      </Link>
    </div>
  );
}
